<ng-container *ngIf="inputUser$ | async as user">
  <article
    class="user-list-item-wrapper"
    [attr.data-cy]="'user-list-item-id-' + user._id">
    <div class="user-list-item__content-wrapper">
      <div
        class="user-list-item__attribute-name"
        (click)="onNameClick($event)">
        <span>{{ formattedUserName$ | async }}</span>
        <mat-icon
          *ngIf="user.role == roleEnum.DISPO"
          class="mx-2"
          [class.is-admin]="
            user?.dispoPermissions?.dispoAccess?.featurePermissions
              ?.isCustomerAdmin
          "
          [matTooltip]="('disponent' | i18n) || 'Disponent'"
          svgIcon="account-star-outline"></mat-icon>
        <mat-icon
          *ngIf="user.role == roleEnum.REQUESTER"
          class="mx-2"
          [matTooltip]="('requester' | i18n) || 'Besteller'"
          svgIcon="person-user-arrow-transfer"></mat-icon>
        <span
          *ngIf="
          isPooler(user) &&
            user.customerInformation?.[(loggedInUser$ | async)?.customerId || ''] &&
            user.customerInformation?.[(loggedInUser$ | async)?.customerId || '']?.poolerType
        ">
          <mat-chip>
            {{user.customerInformation?.[(loggedInUser$ | async)?.customerId || '']?.poolerType?.displayName | uppercase}}
          </mat-chip>
        </span>
      </div>
      <div
        *ngIf="isSuperAdmin$ | async"
        class="user-list-item__attribute-destroy"
        data-cy="user-list-item-impersonate-icon"
        (click)="onImpersonateClick()">
        <mat-icon
          [matTooltip]="'impersonate' | i18n | titlecase"
          svgIcon="account-multiple-outline"></mat-icon>
      </div>
      <div
        *ngIf="showResendEnrollment$ | async"
        class="user-list-item__attribute-destroy"
        (click)="onResendEnrollmentClick(user._id)"
        data-cy="resend-enroll-button">
        <mat-icon
          [matTooltip]="('inviteAgain' | i18n) || 'Erneut einladen'"
          svgIcon="refresh"></mat-icon>
      </div>
      <div
        *ngIf="showReinviteRequest$ | async"
        class="user-list-item__attribute-destroy"
        (click)="onReinviteClick()"
        data-cy="resend-enroll-button">
        <mat-icon
          [matTooltip]="('inviteAgain' | i18n) || 'Erneut einladen'"
          svgIcon="refresh"></mat-icon>
      </div>
      <a
        *ngIf="showJobAvailability$ | async"
        routerLink="/availability"
        [queryParams]="{ userId: user._id }"
        class="user-list-item__attribute-availability"
        data-cy="availability-icon">
        <mat-icon
          [matTooltip]="'jobAvailabilities' | i18n"
          svgIcon="calendar-day-check-availability"></mat-icon>
      </a>

      <a
        *ngIf="showEmploymentAvailability$ | async"
        routerLink="/temp-work/availability"
        [queryParams]="{ userId: user._id }"
        class="user-list-item__attribute-availability"
        data-cy="availability-icon">
        <mat-icon
          [matTooltip]="
            ('employmentAvailabilities' | i18n) || 'Temporär-Verfügbarkeiten'
              | titlecase
          "
          svgIcon="calendar_add_on"></mat-icon>
      </a>
      <a
        *ngIf="showProfileLink$ | async"
        routerLink="/profile"
        [queryParams]="{ userId: user._id }"
        class="user-list-item__attribute-profile"
        data-cy="edit-user-icon">
        <mat-icon
          *ngIf="canUpdateUser$ | async; else viewIcon"
          data-cy="user-list-item-edit-icon"
          [matTooltip]="('edit' | i18n) || 'bearbeiten' | titlecase"
          svgIcon="pencil-outline"></mat-icon>
        <ng-template #viewIcon>
          <mat-icon
            data-cy="user-list-item-view-icon"
            [matTooltip]="('view' | i18n) || 'ansehen' | titlecase"
            svgIcon="eye-outline"></mat-icon>
        </ng-template>
      </a>
      <div
        *ngIf="canDeleteUser$ | async"
        class="user-list-item__attribute-destroy"
        data-cy="user-list-item-delete-icon"
        (click)="onRemoveClick()">
        <mat-icon
          [matTooltip]="('remove' | i18n) || 'entfernen' | titlecase"
          svgIcon="delete-outline"></mat-icon>
      </div>
    </div>
  </article>

  <div
    *ngIf="showDetails$ | async"
    [attr.data-cy]="'user-list-item-details-' + user._id">
    <user-list-item-details
      *ngIf="loggedInUser$ | async as loggedInUser"
      [user]="user"></user-list-item-details>
  </div>
</ng-container>
